<template>
  <div>

    <CCard class="bg-style2 mb-2" :class="border(content)">
      <CCardHeader  class="text-white" :class="background(content)" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <label class="font-weight-bold mt-1"> {{ caption.toUpperCase() }} </label>
      </CCardHeader>

      <CCardBody  >

        <CRow class="mb-3" v-if="control.step !== 2">
          <CCol col="2" class="mt-2"><label class="required font-weight-bold"> {{ $t('assessment') }} </label></CCol>
          <CCol class="pl-2 pr-3 mt-2">
            <label >{{
                this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.prefix.filter(obj => {
                  return (obj.key === lang)
                })[0].value
              }} {{
                this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.firstName.filter(obj => {
                  return (obj.key === lang)
                })[0].value
              }} {{
                this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.lastName.filter(obj => {
                  return (obj.key === lang)
                })[0].value
              }} </label>
          </CCol>
        </CRow>

        <CRow class="mb-3">
          <CCol col="2" class="mt-2"><label class="required font-weight-bold"> {{ $t('idp.suggestions') }} </label>  <span v-if=" content.status === false" class="text-danger">*</span></CCol>
          <CCol col="10" class="pl-2 pr-3">
            <QEditor :content="content" :jkey="jkey" :disabled="control.disabled"/>
          </CCol>
        </CRow>


        <CRow v-if="this.$store.getters['idp/idp'].status.at(-1).state._id == '6723709ab9a2030e40d1b884'">
          <CCol class="text-right">
            <CButton  class="ml-2 " size="sm" :color="(content.status === true)? 'success':'danger' " shape="pill" variant="outline" v-c-tooltip.hover.click="(content.status === true)?$t('agree'):$t('disagree')">
              <span class="font-weight-bold mr-1"><CIcon :name="(content.status === true)?'cil-check-alt':'cil-x'"/> {{ (content.status === true)?$t('agree'):$t('disagree') }} </span>
            </CButton>
          </CCol>

        </CRow>


        <CRow v-if="this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d' && control.state === 3">
          <CCol class="text-right">
            <CButton  class="ml-2 " size="sm" :color="(content.status === true)? 'success':'danger' " shape="pill" variant="outline" v-c-tooltip.hover.click="(content.status === true)?$t('agree'):$t('disagree')">
              <span class="font-weight-bold mr-1"><CIcon :name="(content.status === true)?'cil-check-alt':'cil-x'"/> {{ (content.status === true)?$t('agree'):$t('disagree') }} </span>
            </CButton>
          </CCol>

        </CRow>

        <CRow v-if="control.button">
          <CCol class="text-right">
            <CButton @click="content.status = true" :pressed="content.status == true" class="ml-2 " size="sm" color="success" shape="pill" variant="outline" v-c-tooltip.hover.click="$t('agree')">
              <span class="font-weight-bold mr-1"><CIcon name="cil-check-alt"/> {{ $t('agree') }}</span>
            </CButton>

            <CButton @click="content.status = false" :pressed="content.status == false" class="ml-2 " size="sm" color="danger" shape="pill" variant="outline" v-c-tooltip.hover.click="$t('disagree')">
              <span class="font-weight-bold mr-1"><CIcon name="cil-x"/> {{ $t('disagree') }}</span>
            </CButton>
          </CCol>
        </CRow>

      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import QEditor from "@/projects/components/Util/QEditor.vue";
import moment from "moment";

export default {
  name: 'IDPResults',
  components: {QEditor, Multiselect},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    objs: {
      type: Object,
      default() {
        return null
      }
    },
    content: {
      type: Object,
      default() {
        return null
      }
    },

    jkey: {
      type: String,
      default: 'comment'
    },
    control: {
      type: Object,
      default:{
        isAgree: {
          type: Boolean,
          default: true
        },
        disabled: {
          type: Boolean,
          default: false
        },
      }
    },




    // isAgree: {
    //   type: Boolean,
    //   default: true
    // },
    //
    //
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },



  },

  data: function () {
    return {

    }
  },

  mounted() {

  },

  created() {

  },

  beforeDestroy() {
  },


  methods: {
    border(value){
      if(this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d'){
        if(value.status === true){
          return 'border-success'
        }else{
          return 'border-danger'
        }
      }else{
        return 'border-dark'
      }
    },

    background(value){
      if(this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d'){
        if(value.status === true){
          return 'bg-gradient-success'
        }else{
          return 'bg-gradient-danger'
        }
      }else{
        return 'bg-gradient-dark'
      }
    },
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
    lang(value) {


    },



  }
}
</script>
<style>
.text-right > input[type="number"] {
  text-align: right;
}

.c-switch-input + .c-switch-slider {
  background-color: inherit;
  border-color: #fc1515;
}

.c-switch-input + .c-switch-slider::after {
  color: #fc1515;
}

.c-switch-input + .c-switch-slider::before {
  background-color: #fc1515;
  border-color: #fc1515;
}
</style>
